import { useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { parseMessageTemplatesParam, withMessageTemplatesParam, } from "../utils/messageTemplatesParam";
/**
 * Keeps the open e-mail template editor and its selected type in the URL, so leaving for
 * the library edit route and coming back reopens the same editor. Every change replaces the
 * history entry: the editor is an overlay, and Back must not walk through opened dialogs
 * or switched template types.
 */
export var useMessageTemplatesDialogParam = function () {
    var history = useHistory();
    var location = useLocation();
    var selectedType = useMemo(function () { return parseMessageTemplatesParam(location.search); }, [location.search]);
    var setSelectedType = useCallback(function (type) {
        history.replace({
            search: withMessageTemplatesParam(location.search, type),
        });
    }, [history, location.search]);
    var openDialog = useCallback(function () { return setSelectedType("URGENCE"); }, [setSelectedType]);
    var closeDialog = useCallback(function () { return setSelectedType(null); }, [setSelectedType]);
    return { selectedType: selectedType, openDialog: openDialog, closeDialog: closeDialog, setSelectedType: setSelectedType };
};
